import Shipbook from '@shipbook/browser';
import { version } from '../../package.json';

const APP_KEY = '6992e936e5f744ef551bf93a';
const APP_SECRET = '96065dec6516a7df149082028442019c';
const APP_URL = 'https://staging-api.shipbook.io/v2/';

export async function initLogger() {
  Shipbook.enableInnerLog(true);
  Shipbook.setConnectionUrl(APP_URL);
  await Shipbook.start(APP_KEY, APP_SECRET, { appVersion: version });
}

export function getLogger(moduleName: string) {
  return Shipbook.getLogger(moduleName);
}

export function registerUser(userId: string, userName?: string, fullName?: string, email?: string, phoneNumber?: string) {
  Shipbook.registerUser(userId, userName, fullName, email, phoneNumber);
}

export function logout() {
  Shipbook.logout();
}

export default Shipbook;
